import { slicedToArray as _slicedToArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useRef, useEffect } from 'react';

var PrivacyPolicy = function PrivacyPolicy(_ref) {
  var oneTrustId = _ref.oneTrustId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  var scriptRef = useRef(null);
  var loadPolicyRef = useRef(null);
  useEffect(function () {
    if (typeof document === 'undefined') {
      return undefined;
    }
    if (!scriptRef.current) {
      var script = document.createElement('script');
      script.src = 'https://privacyportal-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js';
      script.type = 'text/javascript';
      script.id = 'otprivacy-notice-script';
      script.charSet = 'UTF-8';
      script.async = true;
      script.innerHTML = 'settings="eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9wcml2YWN5Tm90aWNlcy9zdGF0cy92aWV3cyJ9"';
      script.onload = function () {
        var loadPolicy = document.createElement('script');
        loadPolicy.type = 'text/javascript';
        loadPolicy.charSet = 'UTF-8';
        loadPolicy.innerHTML = "\n          OneTrust.NoticeApi.Initialized.then(function() {\n            OneTrust.NoticeApi.LoadNotices([\n              'https://privacyportal-cdn.onetrust.com/11ccab12-653b-4e89-b206-f783168adc9b/privacy-notices/".concat(oneTrustId, ".json'\n            ]);\n          });\n        ");
        loadPolicyRef.current = loadPolicy;
        document.body.appendChild(loadPolicy);
        setIsLoaded(true);
      };
      scriptRef.current = script;
      document.body.appendChild(script);
    }
    return function () {
      // Remove scripts
      if (scriptRef.current && scriptRef.current.parentNode) {
        scriptRef.current.parentNode.removeChild(scriptRef.current);
        scriptRef.current = null;
      }
      if (loadPolicyRef.current && loadPolicyRef.current.parentNode) {
        loadPolicyRef.current.parentNode.removeChild(loadPolicyRef.current);
        loadPolicyRef.current = null;
      }
    };
  }, [oneTrustId]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoaded && /*#__PURE__*/React__default.createElement("h2", {
    className: "loading"
  }, "Loading Privacy Policy..."), /*#__PURE__*/React__default.createElement("div", {
    id: "otnotice-".concat(oneTrustId)
  }));
};
var PrivacyPolicy$1 = PrivacyPolicy;

export { PrivacyPolicy$1 as default };
//# sourceMappingURL=index.js.map
